import nav from './nav'
import branding from './branding'
import dashboard from './dashboard'
export default {
  direction: 'ltr',
  nav,
  branding,
  dashboard
}
